import React, { useEffect, useRef, useState } from "react"
import { createMediaRenewal } from "./mediaRenewal"

export default function RenewableVideo({ resourceId, src, renew, onError, onLoadedMetadata, ...props }) {
  const [replacement, setReplacement] = useState(null)
  const [error, setError] = useState("")
  const player = useRef(null)
  const recovery = useRef(createMediaRenewal())
  const position = useRef(null)
  const mounted = useRef(true)
  const current = useRef({ src, resourceId })
  if (current.current.src !== src || current.current.resourceId !== resourceId) current.current = { src, resourceId }
  useEffect(() => { mounted.current = true; return () => { mounted.current = false } }, [])
  useEffect(() => { setReplacement(null); setError(""); position.current = null }, [src, resourceId])
  const recover = async (event) => {
    onError?.(event)
    const expected = current.current
    const v = player.current
    position.current = { time: v?.currentTime || 0, playing: v ? !v.paused : false }
    try {
      const url = await recovery.current(resourceId, renew)
      if (!url) throw new Error("This video is no longer available.")
      if (mounted.current && current.current === expected) setReplacement(url)
    } catch (e) { if (mounted.current && current.current === expected) setError(e.message) }
  }
  const loaded = (event) => {
    onLoadedMetadata?.(event)
    const v = player.current
    if (!v || !position.current) return
    const { time, playing } = position.current
    position.current = null
    v.currentTime = Number.isFinite(v.duration) ? Math.min(time, v.duration) : time
    if (playing) v.play().catch(() => {})
  }
  return <>
    <video {...props} ref={player} src={replacement || src} onError={recover} onLoadedMetadata={loaded} />
    {error && <p role="alert" className="text-red-600 text-[14px]">{error}</p>}
  </>
}